import React from "react";
import "./Footer.css";

export const Footer = () =>{
    return(
        <div className="footer">
            <br/>
          <p>    &copy; 2023 Rina Grocery Store. All rights Reserved.</p>
          <p>Made by Reigner Lastimosa</p>
        </div>
    )
}